// ./src/config/operationRights.ts
export const OPERATION_RIGHTS = {
  CREATE: "create",
  DUPLICATE: "duplicate",
  UPDATE: "update",
  REMOVE: "remove",
  PRINT: "print",
  IMPORT: "import",
  EXPORT: "export",
};
